import { MembershipOrder, OrderItem } from "../hooks/useOrderItem";

export type FlattenedOrderItem = {
  name: string;
  quantity: number;
  rate: number;
  amount: number;
};

export function flattenOrderItems(
  orderItems: OrderItem[]
): FlattenedOrderItem[] {
  const flattened: FlattenedOrderItem[] = [];

  orderItems.forEach((item) => {
    if (item.type === "SERVICE_ORDER") {
      const serviceOrder = item as any;

      serviceOrder.serviceItems.forEach((serviceItem: any) => {
        const rate = serviceItem.service.storeServices[0]?.price || 0;
        const quantity = serviceItem.quantity; // Assuming 1 if quantity is not explicitly in Service
        const amount = quantity * rate;

        flattened.push({
          name: serviceItem.service.name,
          quantity,
          rate,
          amount,
        });
      });
    }

    if (item.type === "MEMBERSHIP") {
      const membershipOrder = item as MembershipOrder;
      flattened.push({
        name: "Membership",
        quantity: 1,
        rate: membershipOrder.amount,
        amount: membershipOrder.amount,
      });
    }
  });

  return flattened;
}
